import classNames from 'classnames';
import type React from 'react';

interface ListItemProps {
  children: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLLIElement>;
  selected?: boolean;
  noSpacing?: boolean;
  index?: number;
}

export const ListItem = ({
  children,
  onClick,
  selected,
  noSpacing,
}: ListItemProps) => {
  return (
    <li
      onClick={onClick}
      className={classNames(
        'w-full flex flex-row justify-between items-center rounded transition-all',
        {
          'cursor-pointer': !!onClick,
          'border-blue-400': selected,
          'mb-2.5': !noSpacing,
        }
      )}
    >
      {children}
    </li>
  );
};
